import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigationStart, Router } from '@angular/router';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService, BaseSiteService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CheckoutService } from "src/app/shared/modules/checkout/checkout.service";
import { GeneralPopupComponent } from "src/app/shared/modules/general-popup/general-popup/general-popup.component";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import { CustomInfluenzaService } from "../custom-influenza.service";
import { ProductDetailsInfluenzaComponent } from "../product-details-influenza/product-details-influenza.component";

@Component({
  selector: 'app-reservation-overview',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './reservation-overview.component.html',
  styleUrls: ['./reservation-overview.component.scss']
})
export class ReservationOverviewComponent implements OnInit {
  iseditReservation: boolean = false;
  isEdit: boolean = false;
  reservationDetails: any;
  reservationDetailsEntries: any = [];
  reservationDetailsProducts: any = [];
  estimatedTotal: any;
  deliveryDetails: any = {}; //not seem to be used
  activityList: any;
  totalUnits: number = 0;
  totalDoses: number = 0;
  editable: boolean = true;
  estimatedSavings: number = 0;
  paymentMethod: string;
  paymentCardDetails: string;
  isSticky: boolean = false;
  subTotal: number = 0;
  total: number = 0;
  fluOrderActivityDetailsSub: Subscription;

  constructor(
    private readonly cd: ChangeDetectorRef,
    private baseSiteService: BaseSiteService,
    private readonly user: UserAccountFacade,
    private readonly authService: AuthService,
    private router: Router,
    private readonly modalService: NgbModal,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly checkoutService: CheckoutService,
    private readonly routingService: RoutingService,
    private readonly sharedService: SharedService
  ) { }

  baseSiteId: string;
  userDataSub: Subscription;
  userData: any = [];

  //Flu lock/unlock/extend related - methods
  fluTimer = 29 * 60 * 1000;  //29min
  fluTimerJourneySub: Subscription;
  FluExtendSub: Subscription;
  navigationEndSub: Subscription;
  logoutSub: Subscription;
  viewExcelSub: Subscription;
  @Input() reservationNo: string = '';
  stsFlag: boolean = false; //default false
  @Output() tabSelectedEvent = new EventEmitter<any>();

  checkFluTimerCompletion() {
    this.fluTimerJourneySub = this.influenzaService.fluTimerCompletedSubject.subscribe((res) => {
      if (res) {
        //show extend popup
        this.showFluExtendPopup();
      }
    })
  }
  showFluExtendPopup() {
    const modalRef = this.modalService.open(GeneralPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `fluLockExtendModal ${this.baseSiteId}`
    });
    modalRef.componentInstance.popup_title = 'Influenza Session Expiry';
    modalRef.componentInstance.popup_content = 'Your Influenza session is about to expire.<br />Do you want to continue on Influenza page?';
    modalRef.componentInstance.continueCancelButtons = true;
    this.FluExtendSub = modalRef.componentInstance.extendOrCancelEvent.subscribe((res) => {
      //if extend clicked, extend timer, else navigate to dashboard.
      if (res === 'extend') {
        this.extendLock();
        this.influenzaService.extendFluJourneyTimer(this.fluTimer);
      }
      else {
        // this.router.navigate(['/influenza/dashboard']); //lock will be released on checkNavigationAway
        this.routingService.goByUrl('influenza/dashboard?fromFlu=yes'); //lock will be released on checkNavigationAway
      }
    });
  }

  extendLock() {
    const params = {
      "requstType": 'EXTENDLOCK',    //EXTENDLOCK to EXTEND
      "orderNumber": this.reservationNo  //reservationNo sample - 1092000246
    }

    this.influenzaService.fluLockOrUnlock(this.userData?.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessageNo = res.messageNumber;
          //S+003=LOCKED (EXTEND also), S+002=unlocked, E-005(order not found)=alreadyLocked
          if (lockStatus === 'S' && lockMessageNo === '003') {
            //console.log('lock extended');
          }
          else {
            //console.log('lock extend fail');
          }
        }
      }, errors => {
        //console.log('lock extend fail', errors);
      })
  }

  releaseLock() {
    const params = {
      "requstType": 'UNLOCK',    //UNLOCK to unlock
      "orderNumber": this.reservationNo  //reservationNo sample - 1092000246
    }
    this.influenzaService.fluLockOrUnlock(this.userData?.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessage = res.message;
          const lockMessageNo = res.messageNumber;
          //S+003=LOCKED, S+002=unlocked, E-005(order not found)=alreadyLocked
          if (lockStatus === 'S' && lockMessageNo === '002') {
            this.influenzaService.endFluJourneyTimer();
          }
          // else {
          //  // console.log('unlock fail', lockMessage); //scenario??
          // }
        }
      }, errors => {
        //console.log('unlock fail', errors);
      });
  }
  checkLogout() {
    this.logoutSub = this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.releaseLock(); //AccessDeniedError might come at this time
        this.influenzaService.endFluJourneyTimer();
        this.logoutSub?.unsubscribe();
      }
    });
  }

  print() {
    window.print();
  }

  checkNavigationAway() {
    this.navigationEndSub = this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const nextRoute = event.url; //next route URL
          //add more urls if required.
          if (nextRoute?.includes('fluCategoryPage')) { //Edit reservation page
            //console.log('within flu');//no action needed & dont release lock
          }
          else {
            this.releaseLock();
          }
        }
      });
  }

  redirectToSelectVaccine() {
    this.router.navigate(['/fluCategoryPage'], { queryParams: { 'editReservation': 'yes', 'orderNo': this.reservationNo } });
  }

  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.navigationEndSub?.unsubscribe();
    this.fluTimerJourneySub?.unsubscribe();
    this.FluExtendSub?.unsubscribe();
    this.logoutSub?.unsubscribe();
    this.viewExcelSub?.unsubscribe();
    this.fluOrderActivityDetailsSub?.unsubscribe();
  }
  //removed sticky on small devices also, as taking majority of space.
  // @HostListener('window:scroll', ['$event'])
  // checkScroll() {
  //   if (window.screen.width >= 320 && window.screen.width <= 667) {
  //     if (window.pageYOffset >= 150) {
  //       this.isSticky = true;
  //     } else {
  //       this.isSticky = false;
  //     }
  //   } else {
  //     this.isSticky = false;
  //   }
  //   //this.isSticky = window.pageYOffset >= 400;
  // }
  checkForExcelDownload() {
    this.viewExcelSub = this.influenzaService.viewReservationXlsdownload.subscribe((res) => {
      if (res != null && res == 'reservationOverview') {
        this.exportXls();
      }
    });
  }

  ngOnInit(): void {
    this.checkFluTimerCompletion();
    this.checkNavigationAway();
    this.checkLogout();
    this.checkForExcelDownload();
    this.stsFlag = this.sharedService.getSessionStorage('isStsEligible');
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userData = res;
        this.getActivityDetails();
        this.cd.detectChanges();
        this.userDataSub?.unsubscribe();
      }
    });
    //in general sticky bar not required to show as seen in staging
    // this.influenzaService.printOverviewPage$.subscribe(res => {
    //   this.isSticky = res;
    //   this.cd.detectChanges();
    // });

    // this.influenzaService.detailedReservation.next(this.sharedService.getSessionStorage('fluOverviewData'));
    this.reservationDetails = this.sharedService.getSessionStorage('fluOverviewData'); //reservation details response
    //Filtering hideRow as false entries (for splitting scenario)
    if (this.reservationDetails?.entries) {
      this.reservationDetails.entries = this.reservationDetails.entries.filter(element => element?.quantityStatus != 'Cancelled' && !(element?.hideRow && element?.quantityStatus == 'TBD'));
      this.reservationDetails?.entries.map(entry => {
        entry.pcode = entry.product.code;
      });
      const grouped = _.groupBy(this.reservationDetails?.entries, entry => entry.pcode);
      this.reservationDetailsEntries.push(grouped);
      this.reservationDetailsProducts = Object.keys(this.reservationDetailsEntries[0]);
    }
    //Changing because currently due to ReplaySubject, sometimes reservation details of some other order are showing
    //also due to this approach, on refresh, page goes blank since api is not called on this page.
    // this.influenzaService.detailedReservation.subscribe((res) => { 
    // if(res) {
    // this.reservationDetails = res;
    this.subTotal = this.reservationDetails?.entries != undefined ? this.reservationDetails?.entries.reduce(function (acc, obj) { return acc + (obj?.basePrice?.value * obj?.quantity); }, 0) : 0;
    // this.total = this.subTotal + this.reservationDetails?.totalExciseTax?.value + this.reservationDetails?.totalOtherDiscount?.value + this.reservationDetails?.totalWebDiscount?.value;
    //adding sales tax in the total
    this.total = this.subTotal + this.reservationDetails?.totalExciseTax?.value + this.reservationDetails?.totalSalesTaxPrice?.value + this.reservationDetails?.totalOtherDiscount?.value + this.reservationDetails?.totalWebDiscount?.value;
    // this.totalUnits = this.reservationDetails?.entries != undefined ? this.reservationDetails?.entries.reduce(function (acc, obj) { return acc + obj?.quantity; }, 0) : 0;
    // this.totalDoses = this.reservationDetails?.entries != undefined ? this.reservationDetails?.entries.reduce(function (acc, obj) { return acc + (obj?.quantity * obj?.product?.quantityPerUnit); }, 0) : 0;
    this.totalUnits = this.reservationDetails != undefined ? this.reservationDetails.totalUnitCount : 0;
    this.totalDoses = this.reservationDetails != undefined ? this.reservationDetails.totalDosesCount : 0;
    //this.estimatedSavings = this.reservationDetails != undefined ? Math.abs(this.reservationDetails?.totalOtherDiscount?.value) + Math.abs(this.reservationDetails?.totalWebDiscount?.value) : 0;
    this.estimatedSavings = this.reservationDetails != undefined ? this.reservationDetails?.totalDiscounts?.formattedValue : 0;
    // this.getActivityDetails();
    // this.getReservationPresentations();
    // this.getEstimatedTotal();
    // this.getShippingDetails();
    // this.getContactDetails();
    this.getPaymentData();
    // this.editReservation();
    // this.getReceivingHours();
    // }
    // });
  }

  goToProfileAccount() {
    this.routingService.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Address(s) of Business Unit(s)');
  }

  editReservation() {
    this.routingService.goByUrl('/fluCategoryPage?editReservation=yes&orderNo=' + this.reservationNo);
    //this.sharedService.setSessionStorage('dashedit', true);
  }

  //Method added for STS -shipped case
  manageSts(event) {
    if (event == 'reservation-overview') {
      this.scheduleShipments();
    }
  }
  scheduleShipments() {
    this.tabSelectedEvent.emit('reservationSchedule')
  }

  backToDashboard() {
    // this.router.navigate(['/influenza/dashboard']);
    this.routingService.goByUrl('influenza/dashboard?fromFlu=yes');
  }

  getActivityDetails() {
    // this.influenzaService.getFluOrderActivityDetails(localStorage.getItem('accountId'), this.reservationDetails?.code);
    this.influenzaService.getFluOrderActivityDetails(this.getB2BUid(), this.reservationNo);
    this.fluOrderActivityDetailsSub = this.influenzaService.fluOrderActivityDetails.subscribe(res => {
      if (res) {
        this.activityList = res?.activityList;
        this.cd.detectChanges();
        this.fluOrderActivityDetailsSub?.unsubscribe();
      }
    });
  }
  getB2BUid() {
    let b2bUid: string;
    if ('selectedLocations' in sessionStorage) {
      b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber;
    } else {
      //default location
      b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0].accountNumber;
    }
    return b2bUid;
  }

  // getReservationPresentations() {
  //   // this.reservationDetails.entries.forEach(entry => {
  //   //   let presentation = {};
  //   //   presentation['']
  //   // });
  // }

  // getEstimatedTotal() {
  //   this.deliveryDetails['estimatedTotal']['totalPrice'] = this.reservationDetails?.totalPricewithTax;
  //   this.deliveryDetails['estimatedTotal']['subTotal'] = this.reservationDetails?.subTotal?.formattedValue;
  //   this.deliveryDetails['estimatedTotal']['onlineSavings'] = this.reservationDetails?.totalWebDiscount;
  //   this.deliveryDetails['estimatedTotal']['directSavings'] = this.reservationDetails?.totalOtherDiscount;
  //   this.deliveryDetails['estimatedTotal']['exciseTax'] = this.reservationDetails?.totalExciseTax; 
  //   this.deliveryDetails['estimatedTotal']['salesTax'] = this.reservationDetails?.total?.totalExciseTax; 
  // }

  // getShippingDetails() {
  //   this.deliveryDetails['shippingDetails']['poNumber'] = this.reservationDetails?.purchaseOrderNumber;
  //   this.deliveryDetails['shippingDetails']['soldTo'] = this.reservationDetails?.soldToAddress?.formattedAddress;
  //   this.deliveryDetails['shippingDetails']['shipTo'] = this.reservationDetails?.shippingAddress?.formattedAddress;
  //   this.deliveryDetails['shippingDetails']['attention'] = this.reservationDetails?.attention;
  // }

  // getContactDetails() {
  //   this.deliveryDetails['contactDetails']['name'] = this.reservationDetails?.orderContactData?.name;
  //   this.deliveryDetails['contactDetails']['mobile'] = this.reservationDetails?.orderContactData?.mobileNo;
  //   this.deliveryDetails['contactDetails']['email'] = this.reservationDetails?.orderContactData?.email;
  //   this.deliveryDetails['contactDetails']['billingAddress'] = this.reservationDetails?.billingAddress?.formattedAddress;
  //   this.deliveryDetails['contactDetails']['payerAddress'] = this.reservationDetails?.soldToAddress?.formattedAddress;
  // }

  getPaymentData() {
    // this.paymentMethod = this.reservationDetails?.paymentMethod == 'Bill me later' ? '' : 'Pay by card';
    this.paymentMethod = this.reservationDetails?.paymentMethod;
    // if(this.paymentMethod == 'Bill me later') {
    if (this.paymentMethod && this.paymentMethod?.toLowerCase()?.startsWith('bill')) {
      this.deliveryDetails['paymentMethod'] = 'Bill me later';
    }
    else if (this.paymentMethod == undefined || this.paymentMethod == '') {
      if (this.reservationDetails?.paymentType?.code == 'BILL_ME_LATER') {
        this.paymentMethod = 'Bill me later';
        this.deliveryDetails['paymentMethod'] = 'Bill me later';
      }
      else {
        let cardNumber = this.reservationDetails?.paymentInfo?.cardNumber;
        let cardType = this.reservationDetails?.paymentInfo?.cardType?.code;
        if (cardType == 'EC') {
          cardType = 'Account'
        }
        if (cardType != undefined && cardNumber != undefined) {
          this.paymentCardDetails = `${cardType} ending in ${cardNumber?.substring(6, 10)}`;
        }
        else {
          this.paymentCardDetails = '';
        }
      }
    }
    else { //could be pay by card or pay by checking account

      let cardNumber = this.reservationDetails?.paymentInfo?.cardNumber;
      let cardType = this.reservationDetails?.paymentInfo?.cardType?.code;
      if (cardType == 'EC') {
        cardType = 'Account'
      }
      if (cardType != undefined && cardNumber != undefined) {
        this.paymentCardDetails = `${cardType} ending in ${cardNumber?.substring(6, 10)}`;
      }
      else {
        this.paymentCardDetails = '';
      }
    }
  }

  getReceivingHours() {
    this.deliveryDetails['receivingHours'] = this.reservationDetails?.deliveryHours;
  }

  updateDeliveryTimings(e) {
  }

  enableEdit() {
    this.isEdit = true;
    this.cd.detectChanges();
  }
  cancelEdit() {
    this.isEdit = false;
    this.cd.detectChanges();
  }
  // editReservation(){
  //   this.iseditReservation = true;
  //   this.cd.detectChanges();
  // }
  cancelReservation() {
    this.iseditReservation = false;
    this.cd.detectChanges();
  }

  exportXls() {
    let cartProducts = [];
    this.reservationDetails?.entries.forEach(element => {

      cartProducts.push({
        'Customer': this.reservationDetails?.shipToLoc_id,
        'Material': element?.product?.code,
        'Product Name': element?.product?.variantOptions[0]?.description,
        'Contract Group': element?.contractName,
        'Units': element?.quantity,
        'Doses': element?.quantity * element?.product?.quantityPerUnit,
        // 'Your Price':`($ ${Math.abs(element?.totalPrice?.value).toFixed(2)})`,
        'Your Price': `($ ${Math.abs((element?.basePrice?.value) * element?.quantity).toFixed(2)})`,
        'Direct Savings': `($ ${Math.abs(element?.otherDiscounts?.value).toFixed(2)})`,
        'Online Savings': `($ ${Math.abs(element?.webDiscount?.value).toFixed(2)})`,
        // 'Final Price':`($ ${(element?.totalPrice?.value -
        //             element?.otherDiscounts?.value -
        //             element?.webDiscount?.value -
        //             element?.promptPayDiscount?.value).toFixed(2)})`
        'Final Price': `($ ${(((element?.basePrice?.value) * element?.quantity) + element?.otherDiscounts?.value +
          element?.webDiscount?.value).toFixed(2)})`
      })
    });
    this.influenzaService.downloadXls(cartProducts, 'ReservationDetails_' + this.reservationDetails?.code);
  }

  openResContactPopover(pop) {
    pop.open();
  }

  closeResContactPopover(pop) {
    pop.close();
  }

  productDetails(productDetails) {
    productDetails['flu'] = true;
    const modalRef = this.modalService.open(ProductDetailsInfluenzaComponent, {
      windowClass: `product-details-inf-modal ${this.baseSiteId}`
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = productDetails?.code;
    modalRef.componentInstance.checkout = true;
  }

  // productDetails(productDetails,index) {
  //   /*const modalRef = this.modalService.open(ProductDetailsComponent, {
  //     size: 'md',
  //     scrollable: false,
  //     windowClass: 'patient-edu-modal',
  //   });*/

  //   //const shipToLocID = this.childCarts[index].shipToLoc_id;
  //   //const shipToLocIDArr = [shipToLocID];
  //   const modalRef = this.modalService.open(ProductDetailsComponent, {
  //     windowClass: 'product-details-modal',
  //   });
  //   modalRef.componentInstance.productDetails = productDetails;
  //   //modalRef.componentInstance.standardCartCode = this.stdCartId;
  //   //modalRef.componentInstance.standardCartCode = this.childCarts[index].code;
  //   //modalRef.componentInstance.shipToLocIDArr = shipToLocIDArr;
  //   modalRef.componentInstance.unitSection = 'AddToCart';
  // }
}
